import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const LeadFree = (props) => {
  const name = 'lead_free';

  const {
    label,
    parameters,
    onChangeParameter,
    groupName,
    required,
    tooltip,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <RadioDualComponent
      name={name}
      label={label}
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      disabled={disabled}
      required={required}
      groupName={groupName} />
  );
};

LeadFree.defaultProps = {
  inputId: 'lead-free',
  label: Spree.translations.parameters.lead_free,
  tooltip: Spree.helpForParameters.lead_free,
};

export default LeadFree;
